import { capitalize } from 'radash'
import PetCard from '~components/general/pet-card'
import Label from '~components/ui/label'
import { getMatchRateColor } from '~containers/app/consultation-detail/utils'
import Consultation from '~models/consultation'
import { RequiredWidth, resourceUriDecorate } from '~utils/resource-uri-decorator'
import IssueTag from '../issue-tag'

type SmartSearchCardProps = Readonly<
  Consultation.Level1 & {
    onClick: () => void
  }
>

const SmartSearchCard = ({
  match_rate,
  main_concern,
  issue_keywords,
  generated_title,
  details,
  pet,
  thumbnail_url,
  answer_preview,
  onClick,
}: SmartSearchCardProps) => {
  const issueKeyword = issue_keywords.at(1)

  return (
    <div
      className="cursor-pointer overflow-hidden rounded-2xl dark:bg-gray-900 bg-white shadow-[0px_2px_20px_0px_rgba(0,0,0,0.06)]"
      role="link"
      onClick={onClick}
      onKeyDown={onClick}
      tabIndex={0}
    >
      <div className="relative h-8 w-full bg-white dark:bg-gray-900">
        {!!match_rate && (
          <Label color={getMatchRateColor(match_rate)} className="absolute right-[9px] top-[10px]">
            {match_rate}% Match
          </Label>
        )}
      </div>
      <div className="px-6 pb-6">
        <div className="relative -mt-2 mb-2 text-primary-500 text-headline-3 dark:text-white">
          Q.
        </div>
        <div className="flex justify-between flex-gap-x-2">
          <div>
            {(!!main_concern || !!issue_keywords.length) && (
              <div className="mb-2 flex items-center flex-gap-x-2">
                {main_concern && (
                  <IssueTag className="text-secondary-500 dark:text-secondary-500">
                    {capitalize(main_concern)}
                  </IssueTag>
                )}
                {issueKeyword && <IssueTag>{capitalize(issueKeyword)}</IssueTag>}
              </div>
            )}
            <div className="mb-3 line-clamp-2 text-gray-900 text-title-3 dark:text-white">
              {generated_title || details || ''}
            </div>
          </div>
          {thumbnail_url && (
            <img
              src={resourceUriDecorate(thumbnail_url, {
                width: RequiredWidth.W150,
              })}
              width={64}
              height={64}
              alt="consultation-thumbnail"
              className="size-16 flex-shrink-0 rounded"
              style={{
                objectFit: 'cover',
              }}
            />
          )}
        </div>
        <div className="relative mt-3 text-green-600 text-headline-3 dark:text-white">A.</div>
        <div className="mb-[21px] flex justify-between">
          <div className="mr-4 w-full">
            <div className="line-clamp-2 text-ellipsis text-gray-700 text-body-2 dark:text-white">
              {answer_preview}
            </div>
          </div>
        </div>
        <PetCard
          pet={pet}
          size="sm"
          className="flex items-center flex-gap-x-3 border border-solid border-primary-600 dark:bg-gray-800 dark:border-gray-800"
        >
          <PetCard.Avatar />
          <div className="min-w-0">
            <PetCard.Name className="text-primary-600" />
            <PetCard.Kind />
          </div>
        </PetCard>
      </div>
    </div>
  )
}

export default SmartSearchCard
